import classNames from 'classnames'

const KeyValueInfo = ({
  infoKey = '',
  infoValue = '',
  big = false,
  spaceBtw = false,
  blueValue = false,
  redValue = false,
  boldValue = false,
}) => {
  return (
    <div className={classNames('key_value_info', { big, spaceBtw })}>
      <span className="info_key">{infoKey}</span>
      <span className={classNames('info_value', { blueValue, redValue, boldValue })}>
        {infoValue}
      </span>
    </div>
  )
}

export default KeyValueInfo
